
import LoginFlow from "../components/LoginFlow"
export function Login(){

    return(
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center md:px-6 md:py-6 ">
      <LoginFlow />


    </div>
    )
}